module.exports = __webpack_public_path__ + "static/media/pasl.6cf387e4.svg";